import { observer } from "mobx-react";

import EditModal from "@component/EditModal";
import Skill from "@model/Skill";
import SkillEditVM from "@vm/Edit/Skill";

import SkillForm from "./Form";
import { lazyInject, TYPES } from "../../../inversify.config";

@observer
export default class SkillEdit extends EditModal<Skill> {
  modelName = "skill";
  prefix = "employee";

  @lazyInject(TYPES.SkillEdit)
  vm: SkillEditVM;

  onClose = () => {
    this.router.pageLink(this.uriHelper.employees_skills(this.props.match.params.user_id));
  };

  setIdFromParams() {
    this.vm.init(this.getId(), this.props.match.params.user_id);
  }

  renderModalBody() {
    return (
      <>
        <SkillForm entity={this.vm.entity} />
      </>
    );
  }
}
